import React from 'react';
import PropTypes from 'prop-types';

function Footer({ className, links }) {
  return (
    <footer className={`mt-footer ${className}`}>
      <span className="mt-sr-only" id="link_text">
        opens a new tab
      </span>
      <ul className="mt-footer__links">
        {links.map(({ href, icon = 'new-window', label }, index) => (
          <li key={`mt-footer-link-${index}`}>
            <a
              href={href}
              target="_blank"
              rel="noreferrer noopener"
              aria-describedby="link_text"
            >
              {label || href}
              <span className={`mt-footer__icon mt-footer__icon--${icon}`} />
            </a>
          </li>
        ))}
      </ul>
    </footer>
  );
}

Footer.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      icon: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};

export { Footer };
